import { useEffect } from "react";

const RedirectToMarketingSite = () => {
  useEffect(() => {
    window.location.href = "https://www.inflowparking.com";
  }, []);

  return (
    <div
      style={{
        marginTop: "1rem",
      }}
    >
      <span>If you are not redirected automatically, click</span>{" "}
      <a
        href="https://www.inflowparking.com"
        aria-label="Go to Inflow Parking home page"
      >
        here
      </a>
      <span>.&nbsp;</span>
    </div>
  );
};

export default RedirectToMarketingSite;
